export default __webpack_public_path__ + "static/media/popup_02.2af564f8.mp3";